// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__EicVc","profile":"navbar_profile__8g82a"};